import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fbb3f05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "modal-card-body is-flex-direction-column" }
const _hoisted_3 = { class: "is-full-width mb-4" }
const _hoisted_4 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_5 = { class: "title-five" }
const _hoisted_6 = { class: "is-full-width" }
const _hoisted_7 = { class: "modal-card-foot" }
const _hoisted_8 = { class: "is-flex is-full-width is-justify-content-flex-end" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaSubmitModal',
  props: {
  isActive: Boolean,
  canSubmit: {
    type: Boolean,
    default: true
  },
  isLoading: Boolean
},
  emits: ['close', 'cancel', 'submit'],
  setup(__props, { emit: __emit }) {


const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-active': __props.isActive }, "modal"])
  }, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("article", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _renderSlot(_ctx.$slots, "title")
            ]),
            _createElementVNode("button", {
              class: "delete",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ])
        ]),
        _createElementVNode("section", _hoisted_6, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ]),
      _createElementVNode("footer", _hoisted_7, [
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              disabled: __props.isLoading,
              class: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
            }, _toDisplayString(_ctx.$t('cancel')), 9, _hoisted_9),
            _renderSlot(_ctx.$slots, "submitButton", {}, () => [
              _createElementVNode("button", {
                disabled: !__props.canSubmit || __props.isLoading,
                class: "button is-success",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('submit')))
              }, _toDisplayString(_ctx.$t('submit')), 9, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})